import { CardListItem } from "~/common/api/page";
import { CardPostItem } from "~/common/api/post";
import { CardItemLabel } from "~/widgets/card/components/CardItem";

const getCardItemLabel = (text: string, slug: string): CardItemLabel => {
  switch (slug) {
    case "thought-leadership":
    case "news-thought-leadership":
      return { text: text, color: "#ffffff", backgroundColor: "#3f5df5" }; // Blue
    case "donor-resources":
    case "giving-101":
    case "blog":
    case "other-ways-to-give":
      return { text: text, color: "#000000", backgroundColor: "#c18ae2" }; // Purple
    case "news":
      return { text: text, color: "#000000", backgroundColor: "#89e260" }; // Green
    case "nonprofit-resources":
      return { text: text, color: "#000000", backgroundColor: "#58bbbd" }; // Teal
    case "press-release":
      return { text: text, color: "#ffffff", backgroundColor: "#011936" }; // Night Sky
    default:
      return { text: text, color: "#000000", backgroundColor: "#ec7c75" }; // Coral
  }
};

/**
 * If the card has a category, return the first category as a label for the card
 * CardListItems do not have categories, but CardPostItems do, so we check for the
 * presence of categories
 *
 * We also map the category slug to a specific color for the label, which is used
 * to display the category label on top of the card image. If there are no categories,
 * return undefined so that no label is displayed.
 *
 * @param card The card object to get the category label from.
 * @returns The category label for the card, or undefined if the card has no categories.
 */
export const getCategoryLabel = (
  card: CardListItem | CardPostItem,
): CardItemLabel | undefined => {
  if ("categories" in card && card.categories && card.categories.length > 0) {
    const category = card.categories[0];

    return getCardItemLabel(category.name, category.slug);
  } else if ("label" in card && card.label) {
    const pillData = card.label;

    return {
      text: pillData.text || "",
      color: pillData.color || "#000000",
      backgroundColor: pillData.backgroundColor || "#ffffff",
    };
  }

  return undefined;
};
